import {
    map
} from "jquery"

const machine = {
    state: {
        machineList: null,
        type: [0],
        machineListData: null
    },
    mutations: {
        SET_List: (state, list) => {
            state.machineList = list

        },
        SET_TYPE: (state, type) => {
            state.type = type
        },
        SET_Data: (state, params) => {
            state.machineListData = params
        }
    },
    actions: {
        getMachineList({
            commit
        }, params) {
            let list = new Map()
            params.forEach(item => {
                list.set(item.id, {
                    'name': item.name,
                    'pdescribe': item.pdescribe
                })

            });
            commit('SET_List', list, params)
            commit('SET_Data', params)
        },
        getShowType({
            commit
        }, params) {
            commit('SET_TYPE', params)
        }
    },
}
export default machine